import { asyncRequest, countries, TOMCAT_URL } from 'src/common/index';
import HttpStatus from 'http-status-codes';
import _ from 'lodash';
import AutoComplete from 'material-ui/AutoComplete';
import Checkbox from 'material-ui/Checkbox';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import Slider from 'material-ui/Slider';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import RichEditor from 'src/components/admin/help/rich-editor';
import Avatar from 'src/components/images/avatar';
import Gallery from 'src/components/images/gallery';
import { FINDER_REGIONS, LANGUAGES } from 'src/i18n';
import { Gender } from 'src/utils/constants';
import { iconFormatter } from 'src/utils/formatters';
import fontAwesomeIcons from 'src/utils/icons';
import { Field } from 'redux-form';
import RichEditorMultiLanguage from 'src/components/admin/help/rich-editor-multi-language';
import { isUrl } from 'src/components/misc/validations';
import { Paper } from 'material-ui';
import MultiLanguageDocumentUpload from 'src/components/admin/help/multi-language-document-upload';
import MultiEmailInput from 'src/components/misc/MultiEmailInput';
import { ChromePicker } from 'react-color';
import i18next from 'src/i18n';

export const renderInput = field => {
    return (
        <TextField
            {...field.input}
            type={field.type || 'text'}
            multiLine={field.multiline}
            rows={field.rows}
            rowsMax={field.rowsMax}
            title={field.title}
            fullWidth={true}
            step={field.step}
            disabled={field.disabled}
            hintText={field.hintText ? field.hintText : field.label ? field.label.replace(' *', '') : undefined}
            floatingLabelText={field.label}
            errorText={field.meta.touched && field.meta.error ? field.meta.error : ''}
            inputStyle={field.style}
        />
    );
};
export class renderColorPicker extends Component {
    state = {
        displayColorPicker: false,
        tempColor: '',
    };

    handleClick = () => {
        this.setState({
            displayColorPicker: !this.state.displayColorPicker,
            tempColor: this.props.input.value || '#000000',
        });
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false });
    };

    handleChange = color => {
        this.setState({ tempColor: color.hex });
    };

    handleOk = () => {
        this.props.input.onChange(this.state.tempColor);
        this.setState({ displayColorPicker: false });
    };

    render() {
        const { input, label, fullWidth, style, meta } = this.props;
        const displayBoxColor = input.value || '#000000';

        return (
            <div
                style={{
                    position: 'relative',
                    marginTop: 16,
                    marginBottom: 16,
                    width: fullWidth ? '100%' : 'auto',
                    ...style,
                }}>
                {label && <div style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.3)', marginBottom: 12 }}>{label}</div>}

                <div
                    onClick={this.handleClick}
                    style={{
                        padding: '5px',
                        background: '#fff',
                        borderRadius: '1px',
                        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                        display: 'inline-block',
                        cursor: 'pointer',
                    }}>
                    <div
                        style={{
                            width: '36px',
                            height: '14px',
                            borderRadius: '2px',
                            background: displayBoxColor,
                        }}
                    />
                </div>

                {this.state.displayColorPicker && (
                    <div
                        style={{
                            position: 'fixed',
                            zIndex: '9999',
                            marginTop: '10px',
                            background: '#fff',
                            borderRadius: '4px',
                        }}>
                        <div
                            style={{
                                position: 'fixed',
                                top: '0px',
                                right: '0px',
                                bottom: '0px',
                                left: '0px',
                                zIndex: -1,
                            }}
                            onClick={this.handleClose}
                        />

                        <ChromePicker color={this.state.tempColor} disableAlpha={true} onChange={this.handleChange} />

                        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
                            <button
                                type="button"
                                onClick={this.handleOk}
                                style={{
                                    padding: '4px 12px',
                                    cursor: 'pointer',
                                    background: '#2196F3',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '3px',
                                    fontSize: '12px',
                                }}>
                                OK
                            </button>
                        </div>
                    </div>
                )}

                {meta.touched && meta.error && (
                    <div style={{ fontSize: 12, color: 'rgb(244, 67, 54)', marginTop: 8 }}>{meta.error}</div>
                )}
            </div>
        );
    }
}
export const renderInputNumber = field => {
    return (
        <TextField
            {...field.input}
            type={field.type || 'text'}
            multiLine={field.multiline}
            rows={field.rows}
            rowsMax={field.rowsMax}
            title={field.title}
            fullWidth={true}
            step={field.step}
            disabled={field.disabled}
            hintText={field.hintText ? field.hintText : field.label ? field.label.replace(' *', '') : undefined}
            floatingLabelText={field.label}
            errorText={field.meta.touched && field.meta.error ? field.meta.error : ''}
            inputStyle={field.style}
            max={field.max}
            min={field.min}
            defaultValue={field.defaultValue}
        />
    );
};

export const renderRichTextEditor = field => {
    return (
        <RichEditor
            {...field.input}
            isCreate={field.isCreate}
            placeholder={field.placeholder}
            noLinks={field.noLinks}
            t={field.t}
            disabled={field.disabled}
        />
    );
};

export const renderRichTextEditorMultiLang = field => {
    return (
        <RichEditorMultiLanguage
            {...field.input}
            isCreate={field.isCreate}
            placeholder={field.placeholder}
            noLinks={field.noLinks}
            t={field.t}
            disabled={field.disabled}
        />
    );
};

export const renderMultiLanguageDocumentUpload = field => {
    return (
        <MultiLanguageDocumentUpload
            {...field.input}
            input={field.input}
            isCreate={field.isCreate}
            placeholder={field.placeholder}
            noLinks={field.noLinks}
            upload={field.upload}
            t={field.t}
            disabled={field.disabled}
        />
    );
};
export const renderImageSelector = field => {
    return (
        <div id={field.type + '-file-input'}>
            <Avatar
                handleCroppedImage={documents => {
                    if (field.input.onChange) {
                        if (documents) field.input.onChange(documents[0]);
                        else field.input.onChange(null);
                    }
                }}
                type={field.type}
                disabled={field.disabled}
                t={field.t}
                {...field.input}
            />
        </div>
    );
};

export const renderGalleryImages = field => {
    return (
        <div>
            <Gallery
                multiple={true}
                handleGalleryImages={documents => {
                    if (field.input.onChange) field.input.onChange(documents);
                }}
                type={field.type}
                t={field.t}
                {...field.input}
            />
        </div>
    );
};

export const renderSelectField = field => {
    return (
        <SelectField
            value={field.input.value}
            onChange={(event, index, value) => {
                if (field.input.onChange) field.input.onChange(value);
                if (field.customOnChangeCallback) field.customOnChangeCallback(field.input.name, value);
            }}
            disabled={field.disabled === true}
            floatingLabelText={field.label}
            fullWidth={true}
            errorText={field.meta.touched && field.meta.error ? field.meta.error : ''}
            multiple={field.multiple ? field.multiple : false}
            selectionRenderer={field.selectionRenderer ? field.selectionRenderer : undefined}
            floatingLabelFixed={true}>
            {field.children}
        </SelectField>
    );
};

export const renderSlider = field => {
    if (field.input.value.length >= 0) return null;

    const label = field.labelValueFormat
        ? field.t(field.label, { value: field.labelValueFormat(field.t, field.input.value) })
        : field.t(field.input.value);

    return (
        <div>
            <label>{label}</label>
            <Slider
                min={field.min}
                max={field.max}
                step={field.step}
                sliderStyle={field.sliderStyle ? field.sliderStyle : {}}
                defaultValue={field.input.value}
                value={field.input.value}
                onChange={(event, value) => {
                    if (field.input.onChange) field.input.onChange(value);
                }}
                disabled={field.disabled}
            />
            <span className="error">{field.meta.error && field.meta.error}</span>
        </div>
    );
};

export const renderToggle = field => {
    return (
        <div style={{ height: '72px', display: 'flex', alignItems: 'center' }}>
            <Toggle
                labelPosition={field.labelPosition}
                label={field.label}
                toggled={Boolean(field.input.value)}
                onToggle={(event, isInputChecked) => {
                    if (field.input.onChange) field.input.onChange(isInputChecked);
                }}
            />
        </div>
    );
};

export const genderMenuItems = t => [
    <MenuItem key={-1} value={null} primaryText="-" />,
    <MenuItem key={0} value={Gender.FEMALE} primaryText={t('gender.female')} />,
    <MenuItem key={1} value={Gender.MALE} primaryText={t('gender.male')} />,
    <MenuItem key={2} value={Gender.OTHER} primaryText={t('gender.other')} />,
];

export const nullableBooleanMenuItems = t => [
    <MenuItem key={-1} value={null} primaryText="-" />,
    <MenuItem key={0} value={false} primaryText={t('false')} />,
    <MenuItem key={1} value={true} primaryText={t('true')} />,
];

export const languageMenuItems = () =>
    LANGUAGES.map(language => {
        return <MenuItem key={language.code} value={language.code} primaryText={language.label} />;
    });

export const countryMenuItems = () => {
    const language = i18next.language;
    const translatedCountries = language && countries[language] ? countries[language] : countries.en;
    const sortCountriesFirst = ['', 'DE', 'AT']; // this is in reverse order from the top
    const countriesWithEmpty = translatedCountries.concat({ label: '-', value: '' });
    const sortedCountries = _.sortBy(countriesWithEmpty, [
        country => -sortCountriesFirst.indexOf(country.value),
        country => _.deburr(country.label),
    ]);

    return sortedCountries.map((country, index) => (
        <MenuItem key={index} value={country.value} primaryText={country.label} />
    ));
};

export const supportedRegionItems = () => {
    const language = i18next.language;
    const translatedCountries = language && countries[language] ? countries[language] : countries.en;
    return FINDER_REGIONS.map(region => {
        const label = translatedCountries.find(country => country.value === region).label;
        return <MenuItem key={region} value={region} primaryText={label} />;
    });
};

export const countryMenuItemsForCalculation = () => {
    const language = i18next.language;
    const translatedCountries = language && countries[language] ? countries[language] : countries.en;
    const sortedCountries = _.sortBy(translatedCountries, [country => _.deburr(country.label)]);
    return sortedCountries.map((country, index) => (
        <MenuItem key={index} value={country.value} primaryText={country.label} />
    ));
};

export const iconMenuItems = () =>
    fontAwesomeIcons.map((icon, index) => {
        return <MenuItem key={index} value={icon} primaryText={iconFormatter(icon, icon)} />;
    });

export const renderCheckbox = field => {
    return (
        <Checkbox
            label={field.label}
            checked={field.input.value || false}
            onCheck={(event, value) => {
                if (field.input.onChange) field.input.onChange(value);
                if (field.customOnCheckCallback) field.customOnCheckCallback(value);
            }}
            disabled={field.disabled}
            title={field.title}
        />
    );
};

export const renderCheckboxHtml = ({ input, disabled, labelHtml, customOnCheckCallback, meta }) => {
    const handleLabelClick = e => {
        if (e.target.tagName === 'A') return;
        input.onChange(!input.value); // toggle checkbox manually
    };

    return (
        <div style={{ display: 'flex', marginBottom: 10, alignItems: 'center' }}>
            <Checkbox
                checked={input.value || false}
                onCheck={(event, value) => {
                    if (input.onChange) input.onChange(value);
                    if (customOnCheckCallback) customOnCheckCallback(value);
                }}
                onChange={e => input.onChange(e.target.checked)}
                disabled={disabled}
                style={{ width: 10 }}
                label=" "
            />
            <span
                style={{ cursor: 'pointer', color: meta.touched && meta.error ? 'red' : '' }}
                dangerouslySetInnerHTML={{ __html: labelHtml }}
                onClick={handleLabelClick}
            />
        </div>
    );
};

export const renderMultiSelectCheckboxes = field => (
    <div className="row">
        {field.items.map((item, index) => {
            const label = field.iconProperty ? iconFormatter(item[field.iconProperty], item.name) : item.name;

            return (
                <div key={index} className="col-md-4">
                    <Checkbox
                        label={label}
                        checked={field.input.value.includes(item._links.self.href)}
                        onCheck={(event, checked) => {
                            const currentValues = [].concat(field.input.value);
                            if (checked) currentValues.push(item._links.self.href);
                            else {
                                const itemIndex = currentValues.findIndex(element => element === item._links.self.href);
                                currentValues.splice(itemIndex, 1);
                            }
                            field.input.onChange(currentValues);
                        }}
                    />
                </div>
            );
        })}
    </div>
);

export const validateUrlMultiLanguage = (value, values, props) => {
    const { t } = props;
    const errors = {};
    errors.localizedUrls = {};
    if ('localizedUrls' in values && typeof values.localizedUrls === 'object') {
        for (const [key, value] of Object.entries(values.localizedUrls)) {
            if (!isUrl(value)) errors.localizedUrls[key] = t('error_missing.fill_invalid_url_or_leave_empty');
        }
    }
    if (Object.keys(errors.localizedUrls).length === 0) return '';

    return errors;
};

export const validatePercentage = value => {
    const parsedValue = parseFloat(value);
    return !(isNaN(parsedValue) || parsedValue < 0 || parsedValue > 100);
};

export const validateJson = value => {
    try {
        const json = JSON.parse(value);
        return typeof json === 'object';
    } catch (e) {
        return false;
    }
};

export const validateLocation = value => {
    return value && (!value.address || !value.lat || !value.lng);
};

export class AssociationSearch extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            dataSource: [],
            associations: [],
            autoCompleteService: new google.maps.places.AutocompleteService(),
            geoCoder: new google.maps.Geocoder(),
            ownAssociationSelected: false,
        };
    }

    componentDidMount() {
        asyncRequest({
            method: 'GET',
            endpoint: `${TOMCAT_URL}public/associations`,
        }).then(response => {
            const res = response.json;
            const suggestions = res.map(association => {
                association.contactData.address = association.contactData.fullAddress;
                return {
                    text: association.name,
                    textSearch: association.name.toLowerCase(),
                    value: association.id,
                    contactData: association.contactData,
                };
            });

            this.setState({ associations: suggestions });
        });
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps, this.props) && nextProps.meta.visited === true) this.populateDataSource(nextProps);
    }

    render() {
        const field = this.props;
        const { onChangeAddress, t } = this.props;
        const currentSearchString = field.input.value.school ? field.input.value.school : field.input.value;

        return (
            <>
                <AutoComplete
                    {...field.input}
                    searchText={currentSearchString}
                    fullWidth={true}
                    floatingLabelText={field.label}
                    filter={AutoComplete.noFilter}
                    errorText={field.meta.touched && field.meta.error}
                    dataSource={this.state.dataSource}
                    openOnFocus={true}
                    onUpdateInput={value => {
                        field.input.onChange(value);
                    }}
                    onNewRequest={suggest => {
                        this.populateSchoolData(suggest, field);

                        onChangeAddress(suggest.contactData);
                    }}
                />
                {this.state.ownAssociationSelected && (
                    <>
                        <Field
                            name="registerOrganization"
                            label={t('associations.register_association')}
                            component={renderCheckbox}
                        />
                        <Field
                            name="registrationNumber"
                            type="number"
                            label={`${t('associations.registration_number')} *`}
                            component={renderInput}></Field>
                    </>
                )}
            </>
        );
    }

    populateDataSource(field) {
        let inputString;

        if (field.input.value) {
            if (field.input.value.address) inputString = field.input.value.address;
            else inputString = field.input.value;
        }

        if (inputString && inputString.length > 0) {
            const search = inputString;
            // https://localhost:8443/public/schools/search?keyword=

            const results = this.state.associations.filter(it => it.textSearch.includes(search.toLowerCase()));

            if (results.length === 0) this.setState({ ownAssociationSelected: true });
            this.setState({ dataSource: results });

            // else no suggestions
        } else if (this.state.dataSource.length > 0) this.setState({ dataSource: [] });
    }

    populateSchoolData(suggest, field) {
        field.input.onChange(suggest.text);
        this.setState({ ownAssociationSelected: false });
    }
}

export default class SelectSearchDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: props.initialSearchTerm || '',
            open: false,
            filteredOptions: [],
        };
        this.timer = null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.searchTerm !== this.state.searchTerm || prevProps.options !== this.props.options) {
            this.filterOptions();
        }
    }

    handleInputChange = newValue => {
        this.setState({ searchTerm: newValue, open: true });
        const field = this.props;
        field.input.onChange(newValue);
    };

    filterOptions = () => {
        const { options } = this.props;
        const { searchTerm } = this.state;

        if (!Array.isArray(options)) {
            this.setState({ filteredOptions: [] });
            return;
        }

        const filtered = options.filter(option => option.companyName.toLowerCase().includes(searchTerm.toLowerCase()));
        this.setState({ filteredOptions: filtered });
    };

    handleSuggestionClick = option => {
        this.setState({
            searchTerm: option.companyName,
            open: false,
        });
        const field = this.props;
        field.input.onChange(option.companyName);
    };

    handleFocus = () => {
        // When focused, set open to true and display all options
        this.setState({ open: true, filteredOptions: this.props.options || [] });
        if (this.timer) {
            clearTimeout(this.timer);
        }
    };

    handleBlur = () => {
        this.timer = setTimeout(() => {
            this.setState({ open: false });
        }, 100);
    };

    render() {
        const field = this.props;
        const { open, filteredOptions } = this.state;
        const currentSearchString = field.input.value.companyName ? field.input.value.companyName : field.input.value;

        return (
            <>
                <AutoComplete
                    {...field.input}
                    floatingLabelText={field.label}
                    searchText={currentSearchString}
                    label={field.label}
                    type={field.type || 'text'}
                    filter={AutoComplete.noFilter}
                    dataSource={this.state.filteredOptions}
                    onChange={this.handleInputChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    openOnFocus={true}
                    onUpdateInput={value => {
                        this.handleInputChange(value);
                    }}
                    onNewRequest={suggest => {
                        field.input.onChange(suggest.text);
                    }}
                    fullWidth
                />
                {open && filteredOptions.length > 0 && (
                    <Paper
                        style={{
                            position: 'absolute',
                            zIndex: 1000,
                            width: '100%',
                            maxHeight: 200,
                            overflow: 'auto',
                            top: 'auto',
                        }}>
                        {filteredOptions.map(option => (
                            <MenuItem
                                key={option.companyName}
                                onClick={() => this.handleSuggestionClick(option)}
                                component="div">
                                {option.companyName}
                            </MenuItem>
                        ))}
                    </Paper>
                )}

                {field.input.value && (
                    <>
                        <button
                            className="btn"
                            onClick={e => {
                                e.preventDefault();
                                this.props.duplicateEntry();
                            }}>
                            + {this.props.t('calculation.duplicate_entry')}{' '}
                        </button>{' '}
                    </>
                )}
            </>
        );
    }
}

export class SchoolSearch extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            dataSource: [],
            autoCompleteService: new google.maps.places.AutocompleteService(),
            geoCoder: new google.maps.Geocoder(),
            ownSchoolSelected: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps, this.props) && nextProps.meta.visited === true) this.populateDataSource(nextProps);
    }

    render() {
        const field = this.props;
        const { onChangeAddress, t } = this.props;
        const currentSearchString = field.input.value.school ? field.input.value.school : field.input.value;

        return (
            <>
                <AutoComplete
                    {...field.input}
                    searchText={currentSearchString}
                    fullWidth={true}
                    floatingLabelText={field.label}
                    filter={AutoComplete.noFilter}
                    errorText={field.meta.touched && field.meta.error}
                    dataSource={this.state.dataSource}
                    openOnFocus={true}
                    onUpdateInput={value => {
                        field.input.onChange(value);
                    }}
                    onNewRequest={suggest => {
                        this.populateSchoolData(suggest, field);

                        onChangeAddress(suggest.contactData);
                    }}
                />
                {this.state.ownSchoolSelected && (
                    <Field
                        name="registerOrganization"
                        label={t('contact_data.register_school')}
                        component={renderCheckbox}
                    />
                )}
            </>
        );
    }

    populateDataSource(field) {
        let inputString;

        if (field.input.value) {
            if (field.input.value.address) inputString = field.input.value.address;
            else inputString = field.input.value;
        }

        if (inputString && inputString.length > 0) {
            const search = inputString;
            // https://localhost:8443/public/schools/search?keyword=

            asyncRequest({
                method: 'GET',
                endpoint: `${TOMCAT_URL}public/schools/search?keyword=${search}`,
            }).then(response => {
                const res = response.json;
                const suggestions = res.map(school => {
                    school.contactData.address = school.contactData.fullAddress;
                    return {
                        text: school.name,
                        value: school.id,
                        contactData: school.contactData,
                    };
                });

                if (suggestions.length === 0) this.setState({ ownSchoolSelected: true });
                this.setState({ dataSource: suggestions });
            });

            // else no suggestions
        } else if (this.state.dataSource.length > 0) this.setState({ dataSource: [] });
    }

    populateSchoolData(suggest, field) {
        field.input.onChange(suggest.text);
        this.setState({ ownSchoolSelected: false });
    }
}

export class Location extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            dataSource: [],
            autoCompleteService: new google.maps.places.AutocompleteService(),
            geoCoder: new google.maps.Geocoder(),
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps, this.props) && nextProps.meta.visited === true) this.populateDataSource(nextProps);
    }

    render() {
        const field = this.props;
        const currentSearchString = field.input.value.address ? field.input.value.address : field.input.value;

        return (
            <AutoComplete
                {...field.input}
                searchText={currentSearchString}
                fullWidth={true}
                floatingLabelText={field.label}
                filter={AutoComplete.noFilter}
                errorText={field.meta.touched && field.meta.error}
                dataSource={this.state.dataSource}
                openOnFocus={true}
                onUpdateInput={value => {
                    field.input.onChange(value);
                }}
                onNewRequest={suggest => this.populateLocationDetails(suggest, field)}
            />
        );
    }

    populateDataSource(field) {
        // if input is available check google places api for results
        let inputString;

        if (field.input.value) {
            if (field.input.value.address) inputString = field.input.value.address;
            else inputString = field.input.value;
        }

        if (inputString && inputString.length > 0) {
            const autoCompletionRequest = {
                input: inputString,
            };

            this.state.autoCompleteService.getPlacePredictions(autoCompletionRequest, (res, status) => {
                let suggestions = [];
                if (status === 'OK' && res && res.length > 0) {
                    suggestions = res.map(suggestion => {
                        return {
                            text: suggestion.description,
                            value: suggestion.place_id,
                        };
                    });
                }

                this.setState({ dataSource: suggestions });
            });

            // else no suggestions
        } else if (this.state.dataSource.length > 0) this.setState({ dataSource: [] });
    }

    populateLocationDetails(suggest, field) {
        this.state.geoCoder.geocode(
            suggest.value ? { placeId: suggest.value } : { address: suggest.text },
            (res, status) => {
                if (status === 'OK' && res && res.length > 0) {
                    const location = res[0].geometry.location;

                    const addressComponents = res[0].address_components;

                    const country = this.findComponentShort(addressComponents, 'country');
                    const state = this.findComponentLong(addressComponents, 'administrative_area_level_1');
                    const postCode = this.findComponentLong(addressComponents, 'postal_code');

                    // city is locality or sublocality
                    let city = this.findComponentLong(addressComponents, 'locality');
                    if (city == null) city = this.findComponentLong(addressComponents, 'sublocality');

                    // street is route or intersection
                    let street = this.findComponentLong(addressComponents, 'route');
                    if (street == null) street = this.findComponentLong(addressComponents, 'intersection');

                    // streetNumber is followed by subpremise(s): only append subpremise(s) when streetNumber is not empty
                    let streetNumber = this.findComponentLong(addressComponents, 'street_number');
                    const subpremise = this.findComponentsLong(addressComponents, 'subpremise');
                    if (streetNumber != null && streetNumber.trim() !== '' && subpremise.length > 0)
                        streetNumber = [streetNumber].concat(subpremise).join('/');

                    field.input.onChange({
                        address: res[0].formatted_address,
                        lat: location.lat(),
                        lng: location.lng(),
                        country: country,
                        state: state,
                        postCode: postCode,
                        city: city,
                        street: street,
                        streetNumber: streetNumber,
                    });
                }
            },
        );
    }

    findComponent = (addressComponents, type) => _.find(addressComponents, component => component.types.includes(type));
    findComponentShort = (addressComponents, type) => {
        const component = this.findComponent(addressComponents, type);
        return component != null ? component.short_name : null;
    };
    findComponentLong = (addressComponents, type) => {
        const component = this.findComponent(addressComponents, type);
        return component != null ? component.long_name : null;
    };
    findComponentsLong = (addressComponents, type) =>
        _.map(
            _.filter(addressComponents, component => component.types.includes(type)),
            component => component.long_name,
        );
}

export function pluralizeMinutes(t, minutes) {
    return `${minutes}\u00a0${minutes === 1 ? t('time.minute') : t('time.minutes')}`;
}

export function pluralizeHours(t, hours) {
    return `${hours}\u00a0${hours === 1 ? t('time.hour') : t('time.hours')}`;
}

export function pluralizeDays(t, days) {
    return `${days}\u00a0${days === 1 ? t('time.day') : t('time.days')}`;
}

export function formatMinutes(t, value) {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;

    if (hours >= 24) return formatHours(t, Math.floor(value / 60));

    if (hours === 0) return pluralizeMinutes(t, minutes);
    else if (minutes === 0) return pluralizeHours(t, hours);
    else return `${pluralizeHours(t, hours)} ${pluralizeMinutes(t, minutes)}`;
}

export function formatHours(t, value) {
    const days = Math.floor(value / 24);
    const hours = value % 24;
    if (days === 0) return pluralizeHours(t, hours);
    else if (hours === 0) return pluralizeDays(t, days);
    else return `${pluralizeDays(t, days)} ${pluralizeHours(t, hours)}`;
}

/**
 * Reject if there is something found and has a different id.
 */
export const asyncCheckDuplicate = (t, url, id, field, msg) => {
    return new Promise((resolve, reject) => {
        return fetch(url, {
            credentials: 'include',
        })
            .then(response => {
                if (response.status === HttpStatus.NOT_FOUND)
                    // nothing found -> ok
                    resolve();
                else if (response.status === HttpStatus.OK || response.status === HttpStatus.NO_CONTENT)
                    return response.json();
                else throw { [field]: t('error_hint.error_validating') };
            })
            .then(json => {
                if (id === json.id)
                    // same object -> ok
                    resolve();
                else throw { [field]: msg || t('error_hint.name_already_exists') };
            })
            .catch(error => reject(error));
    });
};

/**
 * Reject if the method returns CONFLICT.
 */
export const asyncCheckConflict = (t, url, field, msg) => {
    return new Promise((resolve, reject) => {
        return fetch(url, {
            credentials: 'include',
        })
            .then(response => {
                if (response.status === HttpStatus.OK || response.status === HttpStatus.NO_CONTENT)
                    // ok
                    resolve();
                else if (response.status === HttpStatus.CONFLICT) {
                    // conflict
                    throw { [field]: msg || t('error_hint.name_already_exists') };
                } else throw { [field]: t('error_hint.error_validating') };
            })
            .catch(error => reject(error));
    });
};

export const renderMultiEmailField = field => {
    const currentValue = Array.isArray(field.input.value) ? field.input.value : [];

    return (
        <div style={{ marginBottom: '16px' }}>
            {field.label && (
                <label style={{ display: 'block', marginBottom: '8px' }}>
                    {field.label} {field.maxEntries && `(Max: ${field.maxEntries})`}
                </label>
            )}
            <MultiEmailInput
                value={currentValue}
                max={field.maxEntries} // Pass the max prop down
                disabled={field.disabled === true}
                placeholder={field.placeholder}
                onBlur={() => field.input.onBlur(currentValue)}
                onChange={newEmails => {
                    if (field.input.onChange) field.input.onChange(newEmails);
                    if (field.customOnChangeCallback) field.customOnChangeCallback(field.input.name, newEmails);
                }}
            />
            {field.meta.touched && field.meta.error && (
                <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>{field.meta.error}</div>
            )}
        </div>
    );
};

export class SearchSelectField extends Component {
    handleUpdateInput = searchText => {
        this.props.input.onChange(searchText);
    };

    handleNewRequest = chosenRequest => {
        this.props.input.onChange(chosenRequest);
    };

    render() {
        const { input, label, options, meta } = this.props;

        const searchText = input.value && typeof input.value === 'object' ? input.value.name : input.value || '';

        return (
            <AutoComplete
                floatingLabelText={label}
                searchText={searchText}
                dataSource={options}
                dataSourceConfig={{ text: 'name', value: 'name' }}
                filter={(searchText, key) => {
                    // Safe check: Convert both to strings and handle null/undefined
                    const safeSearchText = String(searchText || '').toLowerCase();
                    const safeKey = String(key || '').toLowerCase();

                    return safeKey.includes(safeSearchText);
                }}
                onUpdateInput={this.handleUpdateInput}
                onNewRequest={this.handleNewRequest}
                fullWidth={true}
                openOnFocus={true}
                errorText={meta && meta.touched && meta.error ? meta.error : ''}
                menuProps={{ desktop: true }}
            />
        );
    }
}
